import usePrivateAxios from "@/common/api/usePrivateAxios";
import { CompanyRemainingCreditAndBalanceData } from "@/common/types/client/companyRemainingCreditAndBalance.type";
import { useQuery } from "@tanstack/react-query";

const useCompanyRemainingCreditAndBalance = () => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: CompanyRemainingCreditAndBalanceData } }, unknown, CompanyRemainingCreditAndBalanceData>({
    queryKey: ['companyRemainingCreditAndBalance'],
    queryFn: () => privateAxios.get(`/companies/remaining_credit_and_balance`),
    select: (data) => data?.data?.data,
  });
};

export default useCompanyRemainingCreditAndBalance;
